var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useEffect, useMemo, useState } from "react";
import { BigNumber } from "ethers";
import { useWeb3Wallet } from "shared/lib/hooks/useWeb3Wallet";
import { formatUnits } from "ethers/lib/utils";
import { ACTIONS, STEPS } from "./types";
import useVault from "shared/lib/hooks/useVault";
import PreviewStep from "./PreviewStep";
import TransactionStep from "./TransactionStep";
import FormStep from "./FormStep";
import { getAssets, VaultAllowedDepositAssets, getSolanaVaultInstance, isSolanaVault, isNoApproveToken, } from "shared/lib/constants/constants";
import { getSOLAmountByShares, isETHVault } from "shared/lib/utils/vault";
import { usePendingTransactions } from "shared/lib/hooks/pendingTransactionsContext";
import useVaultActionForm from "../../../../hooks/useVaultActionForm";
import { parseUnits } from "@ethersproject/units";
import { useVaultData, useV2VaultData } from "shared/lib/hooks/web3DataContext";
import useVaultContract from "shared/lib/hooks/useVaultContract";
import WarningStep from "./WarningStep";
import { depositSAVAX } from "shared/lib/hooks/useSAVAXDeposit";
import useVaultAccounts from "shared/lib/hooks/useVaultAccounts";
import { useFlexVault } from "shared/lib/hooks/useFlexVault";
import useLidoCurvePool from "shared/lib/hooks/useLidoCurvePool";
import useSTETHDepositHelper from "shared/lib/hooks/useSTETHDepositHelper";
import { useVaultsPriceHistory } from "shared/lib/hooks/useVaultPerformanceUpdate";
import { getAssetColor, getAssetDecimals } from "shared/lib/utils/asset";
import * as anchor from "@project-serum/anchor";
import useLoadingText from "shared/lib/hooks/useLoadingText";
var ActionSteps = function (_a) {
    var _b;
    var _c = _a.vault, vaultOption = _c.vaultOption, vaultVersion = _c.vaultVersion, show = _a.show, onClose = _a.onClose, step = _a.step, onChangeStep = _a.onChangeStep, _d = _a.skipToPreview, skipToPreview = _d === void 0 ? false : _d;
    var ethereumProvider = useWeb3Wallet().ethereumProvider;
    var client = useFlexVault().client;
    var _e = useVaultActionForm(vaultOption), vaultActionForm = _e.vaultActionForm, resetActionForm = _e.resetActionForm, withdrawMetadata = _e.withdrawMetadata;
    var priceHistories = useVaultsPriceHistory().data;
    var firstStep = useMemo(function () {
        var _a;
        if (vaultActionForm.actionType === ACTIONS.withdraw &&
            vaultActionForm.vaultVersion === "v2" &&
            vaultActionForm.withdrawOption === "standard" &&
            !((_a = withdrawMetadata.instantWithdrawBalance) === null || _a === void 0 ? void 0 : _a.isZero())) {
            return STEPS.warningStep;
        }
        return skipToPreview ? STEPS.previewStep : STEPS.formStep;
    }, [
        skipToPreview,
        vaultActionForm.actionType,
        vaultActionForm.vaultVersion,
        vaultActionForm.withdrawOption,
        withdrawMetadata.instantWithdrawBalance,
    ]);
    var _f = useState(""), txhash = _f[0], setTxhash = _f[1];
    // Keep track of the min stETH exchanged
    var loadingText = useLoadingText();
    var _g = useState(), minSTETHAmount = _g[0], setMinSTETHAmount = _g[1];
    var v1Vault = useVault(vaultActionForm.actionType === ACTIONS.migrate
        ? vaultActionForm.migrateSourceVault || vaultOption
        : vaultOption);
    var v2Vault = useVaultContract(vaultOption);
    var _h = useLidoCurvePool(), contract = _h.contract, getMinSTETHAmount = _h.getMinSTETHAmount;
    var stETHDepositHelper = useSTETHDepositHelper(vaultVersion);
    var _j = usePendingTransactions(), pendingTransactions = _j.pendingTransactions, addPendingTransaction = _j.addPendingTransaction;
    var v1VaultBalanceInAsset = useVaultData(vaultOption).vaultBalanceInAsset;
    var _k = useV2VaultData(vaultOption).data, pricePerShare = _k.pricePerShare, decimals = _k.decimals, lockedBalanceInAsset = _k.lockedBalanceInAsset, depositBalanceInAsset = _k.depositBalanceInAsset, withdrawals = _k.withdrawals;
    var v1VaultAccounts = useVaultAccounts("v1").vaultAccounts;
    var asset = useMemo(function () {
        switch (vaultActionForm.actionType) {
            case ACTIONS.deposit:
                return (vaultActionForm.depositAsset ||
                    VaultAllowedDepositAssets[vaultOption][0]);
            default:
                return getAssets(vaultOption);
        }
    }, [vaultActionForm.actionType, vaultActionForm.depositAsset, vaultOption]);
    var vaultBalanceInAsset = useMemo(function () {
        var _a;
        if (vaultActionForm.actionType === "migrate") {
            return (((_a = v1VaultAccounts[vaultActionForm.migrateSourceVault || vaultOption]) === null || _a === void 0 ? void 0 : _a.totalBalance) || BigNumber.from(0));
        }
        switch (vaultVersion) {
            case "v1":
                return v1VaultBalanceInAsset;
            case "earn":
            case "v2":
                var priceHistory = priceHistories.v2[vaultOption].find(function (history) { return history.round === withdrawals.round; });
                return lockedBalanceInAsset
                    .add(depositBalanceInAsset)
                    .add(withdrawals.shares
                    .mul(priceHistory ? priceHistory.pricePerShare : BigNumber.from(0))
                    .div(parseUnits("1", getAssetDecimals(getAssets(vaultOption)))));
        }
    }, [
        depositBalanceInAsset,
        lockedBalanceInAsset,
        priceHistories.v2,
        v1VaultAccounts,
        v1VaultBalanceInAsset,
        vaultOption,
        vaultVersion,
        withdrawals,
        vaultActionForm.actionType,
        vaultActionForm.migrateSourceVault,
    ]);
    var _l = useMemo(function () {
        try {
            var amount_1 = parseUnits(vaultActionForm.inputAmount || "0", decimals);
            return [amount_1, amount_1.toString()];
        }
        catch (err) {
            return [BigNumber.from(0), "0"];
        }
    }, [decimals, vaultActionForm.inputAmount]), amount = _l[0], amountStr = _l[1];
    var cleanupEffects = useCallback(function () {
        setTxhash("");
        if (step === STEPS.submittedStep) {
            resetActionForm();
        }
    }, [resetActionForm, step]);
    var handleClose = useCallback(function () {
        cleanupEffects();
        onClose();
    }, [onClose, cleanupEffects]);
    useEffect(function () {
        if (!show) {
            cleanupEffects();
        }
    }, [show, cleanupEffects]);
    // Whenever the `show` variable is toggled, we need to reset the step back to 0
    useEffect(function () {
        if (!skipToPreview && step === STEPS.formStep) {
            return;
        }
        return function () {
            onChangeStep(firstStep);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [show, firstStep, skipToPreview]);
    useEffect(function () {
        // Fetch stETH rate
        if (vaultOption === "rstETH-THETA" && isNoApproveToken(asset)) {
            if (!amount.isZero()) {
                setMinSTETHAmount(undefined);
                getMinSTETHAmount(amount).then(function (amt) {
                    setMinSTETHAmount(amt);
                });
                return;
            }
            setMinSTETHAmount(BigNumber.from(0));
        }
    }, [amount, asset, getMinSTETHAmount, vaultOption]);
    useEffect(function () {
        // we check that the txhash and check if it had succeed
        // so we can dismiss the modal
        if (step === STEPS.submittedStep && txhash !== "") {
            var pendingTx = pendingTransactions.find(function (tx) { return tx.txhash === txhash; });
            if (pendingTx && pendingTx.status) {
                setTimeout(function () {
                    handleClose();
                }, 300);
            }
        }
    }, [pendingTransactions, txhash, handleClose, step]);
    var handleSwapCurveAndDepositSTETH = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var minSTETHAmount;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getMinSTETHAmount(amount)];
                case 1:
                    minSTETHAmount = _a.sent();
                    if (contract && minSTETHAmount) {
                        return [2 /*return*/, stETHDepositHelper === null || stETHDepositHelper === void 0 ? void 0 : stETHDepositHelper.deposit(minSTETHAmount, { value: amount })];
                    }
                    return [2 /*return*/];
            }
        });
    }); }, [amount, contract, getMinSTETHAmount, stETHDepositHelper]);
    var handleClickConfirmButton = function () { return __awaiter(void 0, void 0, void 0, function () {
        var vault, res, shares, _a, _b, txhash_1, _c, _d, v1Vault_1, v2Vault_1, _e, _f, _g, redeemableAmount, txhash_2, _h, e_1;
        return __generator(this, function (_j) {
            switch (_j.label) {
                case 0:
                    vault = vaultActionForm.vaultVersion === "v1" ? v1Vault : v2Vault;
                    if (!(vault !== null || (isSolanaVault(vaultOption) && client !== null))) return [3 /*break*/, 52];
                    // check illegal state transition
                    if (step !== STEPS.confirmationStep - 1)
                        return [2 /*return*/];
                    onChangeStep(STEPS.confirmationStep);
                    _j.label = 1;
                case 1:
                    _j.trys.push([1, 51, , 52]);
                    res = void 0;
                    shares = void 0;
                    _a = vaultActionForm.actionType;
                    switch (_a) {
                        case ACTIONS.deposit: return [3 /*break*/, 2];
                        case ACTIONS.withdraw: return [3 /*break*/, 19];
                        case ACTIONS.transfer: return [3 /*break*/, 47];
                        case ACTIONS.migrate: return [3 /*break*/, 48];
                    }
                    return [3 /*break*/, 50];
                case 2:
                    _b = vaultOption;
                    switch (_b) {
                        case "rstETH-THETA": return [3 /*break*/, 3];
                        case "rSOL-THETA": return [3 /*break*/, 8];
                        case "rsAVAX-THETA": return [3 /*break*/, 11];
                    }
                    return [3 /*break*/, 16];
                case 3:
                    if (!isNoApproveToken(asset)) return [3 /*break*/, 5];
                    return [4 /*yield*/, handleSwapCurveAndDepositSTETH()];
                case 4:
                    res = _j.sent();
                    return [3 /*break*/, 7];
                case 5: return [4 /*yield*/, vault.depositYieldToken(amountStr)];
                case 6:
                    res = _j.sent();
                    _j.label = 7;
                case 7: return [3 /*break*/, 18];
                case 8:
                    if (!client) return [3 /*break*/, 10];
                    return [4 /*yield*/, client.depositVault(getSolanaVaultInstance(vaultOption), new anchor.BN(amountStr))];
                case 9:
                    txhash_1 = _j.sent();
                    res = { hash: txhash_1 };
                    _j.label = 10;
                case 10: return [3 /*break*/, 18];
                case 11:
                    if (!(asset === "WAVAX")) return [3 /*break*/, 13];
                    return [4 /*yield*/, depositSAVAX(ethereumProvider, amountStr)];
                case 12:
                    _c = _j.sent();
                    return [3 /*break*/, 15];
                case 13: return [4 /*yield*/, vault.deposit(amountStr)];
                case 14:
                    _c = _j.sent();
                    _j.label = 15;
                case 15:
                    res = _c;
                    return [3 /*break*/, 18];
                case 16: return [4 /*yield*/, (isNoApproveToken(asset)
                        ? vault.depositETH({
                            value: amountStr,
                        })
                        : vault.deposit(amountStr))];
                case 17:
                    res = _j.sent();
                    _j.label = 18;
                case 18: return [3 /*break*/, 50];
                case 19:
                    _d = vaultActionForm.vaultVersion;
                    switch (_d) {
                        case "v1": return [3 /*break*/, 20];
                        case "earn": return [3 /*break*/, 23];
                        case "v2": return [3 /*break*/, 23];
                    }
                    return [3 /*break*/, 46];
                case 20:
                    v1Vault_1 = vault;
                    return [4 /*yield*/, v1Vault_1.assetAmountToShares(amountStr)];
                case 21:
                    shares = _j.sent();
                    return [4 /*yield*/, (isETHVault(vaultOption)
                            ? v1Vault_1.withdrawETH(shares)
                            : v1Vault_1.withdraw(shares))];
                case 22:
                    res = _j.sent();
                    return [3 /*break*/, 46];
                case 23:
                    v2Vault_1 = vault;
                    _e = vaultActionForm.withdrawOption;
                    switch (_e) {
                        case "instant": return [3 /*break*/, 24];
                        case "standard": return [3 /*break*/, 31];
                        case "complete": return [3 /*break*/, 39];
                    }
                    return [3 /*break*/, 45];
                case 24:
                    _f = vaultActionForm.vaultOption;
                    switch (_f) {
                        case "rSOL-THETA": return [3 /*break*/, 25];
                        case "rstETH-THETA": return [3 /*break*/, 26];
                    }
                    return [3 /*break*/, 28];
                case 25: return [2 /*return*/];
                case 26: return [4 /*yield*/, vault.withdrawInstantly(amountStr, 0, {
                        gasLimit: 220000,
                    })];
                case 27:
                    res = _j.sent();
                    return [3 /*break*/, 30];
                case 28: return [4 /*yield*/, v2Vault_1.withdrawInstantly(amountStr)];
                case 29:
                    res = _j.sent();
                    _j.label = 30;
                case 30: return [3 /*break*/, 45];
                case 31:
                    _g = vaultActionForm.vaultOption;
                    switch (_g) {
                        case "rSOL-THETA": return [3 /*break*/, 32];
                    }
                    return [3 /*break*/, 36];
                case 32:
                    if (!client) return [3 /*break*/, 35];
                    return [4 /*yield*/, getSOLAmountByShares(Number(vaultActionForm.inputAmount), decimals)];
                case 33:
                    redeemableAmount = _j.sent();
                    return [4 /*yield*/, client.withdrawVault(getSolanaVaultInstance(vaultOption), new anchor.BN(redeemableAmount))];
                case 34:
                    txhash_2 = _j.sent();
                    res = { hash: txhash_2 };
                    _j.label = 35;
                case 35: return [3 /*break*/, 38];
                case 36:
                    shares = amount
                        .mul(BigNumber.from(10).pow(decimals))
                        .div(pricePerShare);
                    return [4 /*yield*/, v2Vault_1.initiateWithdraw(shares)];
                case 37:
                    res = _j.sent();
                    _j.label = 38;
                case 38: return [3 /*break*/, 45];
                case 39:
                    _h = vaultActionForm.vaultOption;
                    switch (_h) {
                        case "rstETH-THETA": return [3 /*break*/, 40];
                    }
                    return [3 /*break*/, 42];
                case 40: return [4 /*yield*/, vault.completeWithdraw({
                        gasLimit: 400000,
                    })];
                case 41:
                    // Special for RibbonV2stETH vault
                    res = _j.sent();
                    return [3 /*break*/, 44];
                case 42: return [4 /*yield*/, v2Vault_1.completeWithdraw()];
                case 43:
                    res = _j.sent();
                    _j.label = 44;
                case 44: return [3 /*break*/, 45];
                case 45: return [3 /*break*/, 46];
                case 46: return [3 /*break*/, 50];
                case 47: 
                // Transfer action is not currently used at all
                return [3 /*break*/, 50];
                case 48: return [4 /*yield*/, vault.migrate()];
                case 49:
                    res = _j.sent();
                    return [3 /*break*/, 50];
                case 50:
                    /**
                     * Append transaction into pending transaction list
                     */
                    switch (vaultActionForm.actionType) {
                        case ACTIONS.deposit:
                            addPendingTransaction({
                                txhash: res.hash,
                                type: "deposit",
                                amount: amountStr,
                                vault: vaultOption,
                                asset: asset,
                            });
                            break;
                        case ACTIONS.withdraw:
                            /**
                             * Standard withdrawal
                             */
                            if (vaultActionForm.withdrawOption === "standard") {
                                addPendingTransaction({
                                    txhash: res.hash,
                                    type: "withdrawInitiation",
                                    amount: amountStr,
                                    vault: vaultOption,
                                });
                                break;
                            }
                            /**
                             * Other type of withdrawals
                             */
                            addPendingTransaction({
                                txhash: res.hash,
                                type: "withdraw",
                                amount: amountStr,
                                vault: vaultOption,
                            });
                            break;
                        case ACTIONS.migrate:
                            addPendingTransaction({
                                txhash: res.hash,
                                type: "migrate",
                                amount: amountStr,
                                vault: vaultOption,
                            });
                            break;
                        case ACTIONS.transfer:
                            addPendingTransaction({
                                txhash: res.hash,
                                type: ACTIONS.transfer,
                                amount: amountStr,
                                transferVault: vaultOption,
                                receiveVault: vaultActionForm.receiveVault,
                            });
                            break;
                    }
                    setTxhash(res.hash);
                    onChangeStep(STEPS.submittedStep);
                    return [3 /*break*/, 52];
                case 51:
                    e_1 = _j.sent();
                    console.error(e_1);
                    handleClose();
                    return [3 /*break*/, 52];
                case 52: return [2 /*return*/];
            }
        });
    }); };
    var stepComponents = (_b = {},
        _b[-1] = (_jsx(WarningStep, { actionType: vaultActionForm.actionType, withdrawOption: vaultActionForm.withdrawOption, vaultOption: vaultOption, vaultVersion: vaultActionForm.vaultVersion, withdrawMetadata: withdrawMetadata, onFormSubmit: function () { return onChangeStep(STEPS.previewStep); } }, void 0)),
        _b[0] = !skipToPreview && (_jsx(FormStep, { vaultVersion: vaultVersion, vaultOption: vaultOption, onFormSubmit: function () { return onChangeStep(STEPS.previewStep); } }, void 0)),
        _b[1] = (_jsx(PreviewStep, { actionType: vaultActionForm.actionType, amount: amount, positionAmount: vaultBalanceInAsset, onClickConfirmButton: handleClickConfirmButton, asset: asset, vaultOption: vaultOption, vaultVersion: vaultVersion, receiveVaultOption: vaultActionForm.receiveVault, withdrawOption: vaultActionForm.withdrawOption, estimatedSTETHDepositAmount: minSTETHAmount
                ? "~" + parseFloat(formatUnits(minSTETHAmount, 18)).toFixed(4) + " stETH"
                : loadingText }, void 0)),
        _b[2] = _jsx(TransactionStep, { color: getAssetColor(asset) }, void 0),
        _b[3] = _jsx(TransactionStep, { txhash: txhash, color: getAssetColor(asset) }, void 0),
        _b);
    return _jsx(_Fragment, { children: stepComponents[step] }, void 0);
};
export default ActionSteps;
//# sourceMappingURL=ActionSteps.js.map